import { useMemo } from "react"
import rgbHex from "rgb-hex";

export const mainStyleFormats = ['h1', 'h2', 'h3', 'h4', 'paragraph'];
export function useTinyStyleFormats(props) {
  return useMemo(() => ({
    formats: {
      removeformat: [
        {
          selector:
            "h1,h2,h3,h4,strong,b,em,i,span,p,underline,sub,sup",
          remove: "all",

          deep: true,
        },
      ],
      list: { block: "li" },
      // unknown: { block: "span" },
      none: {
        title: "None",
        block: "div",
        selector: "impossible",
        styles: {
          color: "#000000",
          backgroundColor: "",
          fontFamily: props.selectedFont,
          fontSize: "14px",
          paddingBottom: "",
          fontStyle: "",
          fontWeight: "",
          lineHeight: "",
          textDecoration: "",
        },
        remove: "all",
      },
      default_format: {
        title: "None",
        block: "p",
        selector: "impossible",
        styles: {
          color: "",
          backgroundColor: "",
          fontFamily: props.selectedFont,
          fontSize: "14px",
          paddingBottom: "",
          fontStyle: "",
          fontWeight: "",
          lineHeight: "",
          textDecoration: "",
        },
        attributes: { class: 'tinymce-default-format' },
        remove: "all",
      },
      noneForRemoveFormat: {
        title: "None",
        block: "div",
        selector: "impossible",
        styles: {
          color: "#000000",
          backgroundColor: "",
          fontFamily: props.selectedFont,
          fontSize: "14px",
          paddingBottom: "",
          fontStyle: "",
          fontWeight: "",
          lineHeight: "",
          textDecoration: "",
        },
        remove: "all",
      },
      p_all: {
        block: "p",
        selector: "impossible",
      },
      p: {
        title: "Paragraph",
        // selector: "p,div:not(.mce-content-body),h1,h2,h3,h4",
        block: "p",
        styles: {
          color: props.elementsFont.p.color
            ? "#" +
            rgbHex(`
                ${props.elementsFont.p.color.r},
                ${props.elementsFont.p.color.g},
                ${props.elementsFont.p.color.b}
                `)
            : "#000000",
          fontFamily: props.elementsFont.p.font_family
            ? props.elementsFont.p.font_family
            : "Montserrat",
          fontSize: props.elementsFont?.p?.font_size
            ? `${props.elementsFont.p.font_size}px`
            : "16px",

          paddingBottom: props.elementsFont.p.margin_bottom
            ? props.elementsFont.p.margin_bottom + "px"
            : "0px",

          fontStyle: props.elementsFont.p.font_style || "",
          fontWeight: "",
          lineHeight: props.elementsFont.p.line_height,
          textDecoration: props.elementsFont.p.text_decoration || "",
          marginBottom: "0px",
        },

        deep: true,
        exact: true,
        remove: "all",
        merge_with_parents: false,
        merge_siblings: false,
      },
      h1_all: {
        block: "h1",
        selector: "impossible",
      },
      h1: {
        title: "Header 1",
        // selector: "p,div:not(.mce-content-body),h1,h2,h3,h4",
        block: "h1",
        styles: {
          color: props.elementsFont.h1.color
            ? "#" +
            rgbHex(`
                ${props.elementsFont.h1.color.r},
                ${props.elementsFont.h1.color.g},
                ${props.elementsFont.h1.color.b}
                `)
            : "",
          fontFamily: props.elementsFont.h1.font_family
            ? props.elementsFont.h1.font_family
            : "Open Sans",
          fontSize: props.elementsFont?.h1?.font_size ? `${props.elementsFont.h1.font_size}px` : "36px",

          paddingBottom: props.elementsFont.h1.margin_bottom
            ? props.elementsFont.h1.margin_bottom + "px"
            : "0px",
          backgroundColor:
            props.elementsFont.h1.background_color &&
              props.elementsFont.h1.background_color.a !== 0
              ? "#" +
              rgbHex(`
                              ${props.elementsFont.h1.background_color.r},
                              ${props.elementsFont.h1.background_color.g},
                              ${props.elementsFont.h1.background_color.b}
                              `)
              : "",
          fontStyle: props.elementsFont.h1.font_style || "",
          fontWeight: "",
          lineHeight: props.elementsFont.h1.line_height,
          textDecoration: props.elementsFont.h1.text_decoration || "",
          marginBottom: "0px",
        },
        deep: true,
        exact: true,
        merge_with_parents: false,
        merge_siblings: false,
        remove: "all",
      },
      h2_all: {
        block: "h2",
        selector: "impossible",
      },
      h2: {
        title: "Header 2",
        // selector: "p,div:not(.mce-content-body),h1,h2,h3,h4",
        // selector: "*",
        block: "h2",
        styles: {
          color: props.elementsFont.h2.color
            ? "#" +
            rgbHex(`
                ${props.elementsFont.h2.color.r},
                ${props.elementsFont.h2.color.g},
                ${props.elementsFont.h2.color.b}
                `)
            : "",
          fontFamily: props.elementsFont.h2.font_family || "Open Sans",
          fontSize: props.elementsFont?.h2?.font_size ? `${props.elementsFont.h2.font_size}px` : "32px",
          paddingBottom: props.elementsFont.h2.margin_bottom
            ? props.elementsFont.h2.margin_bottom + "px"
            : "0px",
          backgroundColor:
            props.elementsFont.h2.background_color &&
              props.elementsFont.h2.background_color.a !== 0
              ? "#" +
              rgbHex(`
                ${props.elementsFont.h2.background_color.r},
                ${props.elementsFont.h2.background_color.g},
                ${props.elementsFont.h2.background_color.b}
                `)
              : "",
          fontStyle: props.elementsFont.h2.font_style || "",
          fontWeight: "",
          lineHeight: props.elementsFont.h2.line_height,
          textDecoration: props.elementsFont.h2.text_decoration || "",
          marginBottom: "0px",
        },
        deep: true,
        exact: true,
        remove: "all",
        merge_with_parents: false,
        merge_siblings: false,
      },
      h3_all: {
        block: "h3",
        selector: "impossible",
      },
      h3: {
        title: "Header 3",
        // selector: "p,div:not(.mce-content-body),h1,h2,h3,h4",
        block: "h3",
        styles: {
          color: props.elementsFont.h3.color
            ? "#" +
            rgbHex(`
                ${props.elementsFont.h3.color.r},
                ${props.elementsFont.h3.color.g},
                ${props.elementsFont.h3.color.b}
                `)
            : "",
          fontFamily: props.elementsFont.h3.font_family || "Open Sans",
          fontSize: props.elementsFont?.h3?.font_size ? `${props.elementsFont.h3.font_size}px` : "28px",
          paddingBottom: props.elementsFont.h3.margin_bottom
            ? props.elementsFont.h3.margin_bottom + "px"
            : "0px",
          backgroundColor:
            props.elementsFont.h3.background_color &&
              props.elementsFont.h3.background_color.a !== 0
              ? "#" +
              rgbHex(`
                ${props.elementsFont.h3.background_color.r},
                ${props.elementsFont.h3.background_color.g},
                ${props.elementsFont.h3.background_color.b}
                `)
              : "",
          fontStyle: props.elementsFont.h3.font_style || "",
          fontWeight: "",
          lineHeight: props.elementsFont.h3.line_height,
          textDecoration: props.elementsFont.h3.text_decoration || "",
          marginBottom: "0px",
        },
        deep: true,
        exact: true,
        remove: "all",
        merge_with_parents: false,
        merge_siblings: false,
      },
      h4_all: { block: "h4", selector: "impossible" },
      h4: {
        title: "Header 4",
        block: "h4",
        // selector: "p,div:not(.mce-content-body),h1,h2,h3,h4",
        styles: {
          color: props.elementsFont.h4.color
            ? "#" +
            rgbHex(`
                ${props.elementsFont.h4.color.r},
                ${props.elementsFont.h4.color.g},
                ${props.elementsFont.h4.color.b}
                `)
            : "",
          fontFamily: props.elementsFont.h4.font_family || "Open Sans",
          fontSize: props.elementsFont?.h4?.font_size ? `${props.elementsFont.h4.font_size}px` : "20px",
          paddingBottom: props.elementsFont.h4.margin_bottom
            ? props.elementsFont.h4.margin_bottom + "px"
            : "0px",
          backgroundColor:
            props.elementsFont.h4.background_color &&
              props.elementsFont.h4.background_color.a !== 0
              ? "#" +
              rgbHex(`
                ${props.elementsFont.h4.background_color.r},
                ${props.elementsFont.h4.background_color.g},
                ${props.elementsFont.h4.background_color.b}
                `)
              : "",
          fontStyle: props.elementsFont.h4.font_style || "",
          fontWeight: "",
          lineHeight: props.elementsFont.h4.line_height,
          textDecoration: props.elementsFont.h4.text_decoration || "",
          marginBottom: "0px",
        },
        deep: true,
        exact: true,
        remove: "all",

        merge_with_parents: false,
        merge_siblings: false,
      },
      // --- LIST FORMATS ---
      p_list: {
        title: "Paragraph (List)",
        block: "li",
        selector: "li",
        styles: {
          color: props.elementsFont.p.color
            ? "#" +
            rgbHex(`
                ${props.elementsFont.p.color.r},
                ${props.elementsFont.p.color.g},
                ${props.elementsFont.p.color.b}
                `)
            : "#000000",
          fontFamily: props.elementsFont.p.font_family
            ? props.elementsFont.p.font_family
            : "Montserrat",
          fontSize: props.elementsFont?.p?.font_size
            ? `${props.elementsFont.p.font_size}px`
            : "16px",
          fontStyle: props.elementsFont.p.font_style || "",
          fontWeight: "",
          lineHeight: props.elementsFont.p.line_height,
          textDecoration: props.elementsFont.p.text_decoration || "",
          marginBottom: "0px",
          paddingBottom: "0px",
        },
        deep: true,
        exact: true,
        remove: "all",
        merge_with_parents: false,
        merge_siblings: false,
      },
      h1_list: {
        title: "Header 1 (List)",
        block: "li",
        selector: "li",
        styles: {
          color: props.elementsFont.h1.color
            ? "#" +
            rgbHex(`
                ${props.elementsFont.h1.color.r},
                ${props.elementsFont.h1.color.g},
                ${props.elementsFont.h1.color.b}
                `)
            : "",
          fontFamily: props.elementsFont.h1.font_family
            ? props.elementsFont.h1.font_family
            : "Open Sans",
          fontSize: props.elementsFont?.h1?.font_size ? `${props.elementsFont.h1.font_size}px` : "36px",
          backgroundColor:
            props.elementsFont.h1.background_color &&
              props.elementsFont.h1.background_color.a !== 0
              ? "#" +
              rgbHex(`
                              ${props.elementsFont.h1.background_color.r},
                              ${props.elementsFont.h1.background_color.g},
                              ${props.elementsFont.h1.background_color.b}
                              `)
              : "",
          fontStyle: props.elementsFont.h1.font_style || "",
          fontWeight: "",
          lineHeight: props.elementsFont.h1.line_height,
          textDecoration: props.elementsFont.h1.text_decoration || "",
          marginBottom: "0px",
          paddingBottom: "0px",
        },
        deep: true,
        exact: true,
        merge_with_parents: false,
        merge_siblings: false,
        remove: "all",
      },
      h2_list: {
        title: "Header 2 (List)",
        block: "li",
        selector: "li",
        styles: {
          color: props.elementsFont.h2.color
            ? "#" +
            rgbHex(`
                ${props.elementsFont.h2.color.r},
                ${props.elementsFont.h2.color.g},
                ${props.elementsFont.h2.color.b}
                `)
            : "",
          fontFamily: props.elementsFont.h2.font_family || "Open Sans",
          fontSize: props.elementsFont?.h2?.font_size ? `${props.elementsFont.h2.font_size}px` : "32px",
          backgroundColor:
            props.elementsFont.h2.background_color &&
              props.elementsFont.h2.background_color.a !== 0
              ? "#" +
              rgbHex(`
                ${props.elementsFont.h2.background_color.r},
                ${props.elementsFont.h2.background_color.g},
                ${props.elementsFont.h2.background_color.b}
                `)
              : "",
          fontStyle: props.elementsFont.h2.font_style || "",
          fontWeight: "",
          lineHeight: props.elementsFont.h2.line_height,
          textDecoration: props.elementsFont.h2.text_decoration || "",
          marginBottom: "0px",
          paddingBottom: "0px",
        },
        deep: true,
        exact: true,
        remove: "all",
        merge_with_parents: false,
        merge_siblings: false,
      },
      h3_list: {
        title: "Header 3 (List)",
        block: "li",
        selector: "li",
        styles: {
          color: props.elementsFont.h3.color
            ? "#" +
            rgbHex(`
                ${props.elementsFont.h3.color.r},
                ${props.elementsFont.h3.color.g},
                ${props.elementsFont.h3.color.b}
                `)
            : "",
          fontFamily: props.elementsFont.h3.font_family || "Open Sans",
          fontSize: props.elementsFont?.h3?.font_size ? `${props.elementsFont.h3.font_size}px` : "28px",
          backgroundColor:
            props.elementsFont.h3.background_color &&
              props.elementsFont.h3.background_color.a !== 0
              ? "#" +
              rgbHex(`
                ${props.elementsFont.h3.background_color.r},
                ${props.elementsFont.h3.background_color.g},
                ${props.elementsFont.h3.background_color.b}
                `)
              : "",
          fontStyle: props.elementsFont.h3.font_style || "",
          fontWeight: "",
          lineHeight: props.elementsFont.h3.line_height,
          textDecoration: props.elementsFont.h3.text_decoration || "",
          marginBottom: "0px",
          paddingBottom: "0px",
        },
        deep: true,
        exact: true,
        remove: "all",
        merge_with_parents: false,
        merge_siblings: false,
      },
      h4_list: {
        title: "Header 4 (List)",
        block: "li",
        selector: "li",
        styles: {
          color: props.elementsFont.h4.color
            ? "#" +
            rgbHex(`
                ${props.elementsFont.h4.color.r},
                ${props.elementsFont.h4.color.g},
                ${props.elementsFont.h4.color.b}
                `)
            : "",
          fontFamily: props.elementsFont.h4.font_family || "Open Sans",
          fontSize: props.elementsFont?.h4?.font_size ? `${props.elementsFont.h4.font_size}px` : "20px",
          backgroundColor:
            props.elementsFont.h4.background_color &&
              props.elementsFont.h4.background_color.a !== 0
              ? "#" +
              rgbHex(`
                ${props.elementsFont.h4.background_color.r},
                ${props.elementsFont.h4.background_color.g},
                ${props.elementsFont.h4.background_color.b}
                `)
              : "",
          fontStyle: props.elementsFont.h4.font_style || "",
          fontWeight: "",
          lineHeight: props.elementsFont.h4.line_height,
          textDecoration: props.elementsFont.h4.text_decoration || "",
          marginBottom: "0px",
          paddingBottom: "0px",
        },
        deep: true,
        exact: true,
        remove: "all",
        merge_with_parents: false,
        merge_siblings: false,
      },
    },
  }), [props]);
}